import { toast } from "react-toastify";
import { ChannelAPI } from "../constants/apiRoutes";
import { channelActions } from "../reducers/channel";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewChannel = (data, navigate) => {
  return async (dispatch) => {
    dispatch(channelActions.actionStart());    
    try {
      await apiService.postMultipart(ChannelAPI.create(), data);
      dispatch(channelActions.actionSuccess("create")); 
    } catch (err) {
      dispatch(channelActions.clearError()); 
      handleError(err);
    }
  };
};

export const updateChannel = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(channelActions.actionStart());    
    return apiService
      .putMultipart(ChannelAPI.update(id), data)
      .then((response) => {
        dispatch(channelActions.actionSuccess("update"));        
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteChannel = (id) => {
  return (dispatch) => {
    return apiService
      .delete(ChannelAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali kanal", {
          theme: "colored",
        });

        dispatch(fetchChannelList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChannelList = () => {
  return (dispatch) => {
    return apiService
      .get(ChannelAPI.list())
      .then((response) => {
        dispatch(channelActions.fetchChannelList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChannelFormList = () => {
  return (dispatch) => {
    return apiService
      .get(ChannelAPI.form())
      .then((response) => {
        dispatch(channelActions.fetchChannelFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChannelById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(ChannelAPI.getById(id))
      .then((response) => {
        dispatch(channelActions.fetchChannelDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
